import {Injectable, EventEmitter} from "@angular/core";
import {Http, Response, URLSearchParams, Jsonp, Headers} from "@angular/http";
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/switchMap';

import {environment as env} from "../../../../environments/environment";
import {User} from "../../models/user";
import {Observable} from "rxjs";

export const localstorage_key_name = 'user';
export const localstorage_token_name = 'user_token';

@Injectable()
export class UserService {
    active_user: User;
    token: string;

    user_refreshed = new EventEmitter<User>();

    private csrf_headers: Headers;

    private post_login_url = 'api/users/v1/login';
    private get_logout_url = 'api/users/v1/logout';
    private post_signup_url = 'api/users/v1/sign-up';
    private post_forgot_password_url = '/api/users/v1/forgotten-password';
    private post_reset_password_url = '/api/users/v1/reset-password';

    constructor(
        private http: Http
    ){
        let ls_value = window.localStorage.getItem(localstorage_key_name);
        if(ls_value){
            this.active_user = <User>JSON.parse(ls_value);
        }

        let ls_token = window.localStorage.getItem(localstorage_token_name);
        if(ls_token){
            this.token = ls_token.substring(1,ls_token.length - 1);
        }

        this.csrf_headers = new Headers();
        this.csrf_headers.set("X-Requested-With", "XMLHttpRequest");
    }

    get host(){
        if(window.location.hostname == "localhost"){
            return 'http://' + window.location.host;
        }

        if(env.forceDefaultServicesDomain == true)
        {
            return env.defaultServicesDomain;
        }

        //replace subdomain
        let parts = window.location.hostname.split('.');
        if(parts.length == 3)
        {
            return "https://services."+parts[1]+"."+parts[2];
        }

        return window.location.hostname;
    }

    loggedIn(): boolean {
        return !! this.active_user;
    }

    isAdmin(): boolean {
        if(! this.loggedIn()){
            return false;
        }

        return this.active_user.group.is_admin;
    }

    login(email, password): any {
         return this.http.post(
                this.host + '/' + this.post_login_url,
                {
                    email: email,
                    password: password,
                    product: env.productname,
                    device_name: navigator.appVersion
                }
         )
             .map(result => {
                 this._save_user(result);
                 return result;
             });
    }

    private _save_user(http_result: Response){
        this.active_user = <User> http_result.json().data.user;

        window.localStorage.setItem(
            localstorage_key_name,
            JSON.stringify(this.active_user)
        );

        this.token = http_result.json().data.token;

        window.localStorage.setItem(
            localstorage_token_name,
            JSON.stringify(this.token)
        );

        return true;
    }

    logout(): void {
        let params: URLSearchParams = new URLSearchParams();
        params.set('token', this.token);

        this.http.get(
                this.host+'/'+this.get_logout_url,
                {
                    search: params
                }
            )
            .toPromise()
            .then(() => {
                window.localStorage.removeItem(localstorage_key_name);
                window.localStorage.removeItem(localstorage_token_name);

                this.active_user = null;
                this.token = null;
            });
    }

    signup(fullname: string, email: string, password: string) : Promise<boolean> {
        return this.http.post(
            this.host+'/'+this.post_signup_url,
            {
                email,
                password,
                fullname
            }
        )
            .toPromise()
            .then(() => true)
            .catch((error) => Promise.reject(error));
    }

    forgot_password(email): Promise<any>{
        return this.http.post(
            this.host+'/'+this.post_forgot_password_url,
            {
                email
            }
        )
            .toPromise()
            .then(() => true)
            .catch(error => Promise.reject(error));
    }

    reset_password(password, code): Promise<any>{
        return this.http.post(
            this.host+'/'+this.post_reset_password_url,
            {
                password,
                code
            }
        )
            .toPromise()
            .then(() => true)
            .catch(error => Promise.reject(error));
    }

    refresh_group(): void{
        let params = new URLSearchParams();
        params.set('token', this.token);

        let result = this.http.get(
                this.host+'/'+'api/users/v1/reauthorize/' + this.active_user.email,
                {
                    search: params
                }
            );

        result.subscribe(data => {
            this.active_user.group = data.json().group;

            window.localStorage.setItem(
                localstorage_key_name,
                JSON.stringify(this.active_user)
            );

            this.user_refreshed.emit(this.active_user);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/api_v1/user.service.ts